export default {
    message:'message'
}